export const normalizeProductCategories = (value) => [...new Set(
  (Array.isArray(value) ? value : value == null ? [] : [value])
    .filter((item) => typeof item === "string")
    .map((item) => item.trim())
    .filter(Boolean),
)];
